<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.fhead.peers')}} Map</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card v-loading="Loading"
                     class="box-card center" style="margin-top: 16px">
                <div class="echarts">
                   Sum： {{this.sum}}
                    <div :class="className" :id="id" :style="{height:height,width:width}" ref="myEchart"></div>
                    <div style="text-align: center">
                        <el-table
                                :data="allData"
                                style="width: 100%">
                            <el-table-column
                                    prop="name"
                                    label="Country"
                                    width="180">
                            </el-table-column>
                            <el-table-column
                                    prop="value"
                                    label="Sum"
                                    width="180">
                            </el-table-column>

                        </el-table>
                        <div style="margin-top: 20px">
                            Hong Kong belongs to China
                        </div>
                    </div>
                </div>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from '../fhead.vue';
    import echarts from "echarts";
    import 'echarts/map/js/world.js'

    export default {
        name: 'peersMap',
        props: {
            className: {
                type: String,
                default: "yourClassName"
            },
            id: {
                type: String,
                default: "yourID"
            },
            width: {
                type: String,
                default: "100%"
            },
            height: {
                type: String,
                default: "400px"
            }
        },
        data() {
            return {
                title: "图表",
                placeholder: "用户名/电话",
                find: "2", //1显示新增按钮，2显示导入按钮，若不显示这两个按钮可以写0或者不写值
                chart: null,
                allData: [],
                allHaveData: [],
                Loading: false,
                sum:0
            };
        },
        components: {
            fhead
        },
        mounted() {
            this.getPeer();
        },
        beforeDestroy() {
            if (!this.chart) {
                return;
            }
            this.chart.dispose();
            this.chart = null;
        },
        methods: {
            getPeer() {
                this.$ajax({
                    method: 'get',
                    url: 'https://api.hebeblock.com/login/nodes'
                }).then(response => {
                    response.list.forEach(item => {
                        item.name = item.country
                        item.value = item.count
                        this.sum=this.sum+item.count;

                    })
                    this.allData = response.list;
                    this.initChart();
                });
            },
            chinaConfigure() {
                let myChart = echarts.init(this.$refs.myEchart1); //这里是为了获得容器所在位置
                myChart.setOption({ // 进行相关配置
                    //backgroundColor: "#02AFDB",
                    backgroundColor: "red",
                    tooltip: {}, // 鼠标移到图里面的浮动提示框
                    dataRange: {
                        show: false,
                        min: 0,
                        max: 1000000,
                        text: ['High', 'Low'],
                        realtime: true,
                        calculable: true,
                        //color: ['orangered', 'yellow', 'lightskyblue']
                        color: ['white', 'yellow', 'lightskyblue']
                    },
                    geo: { // 这个是重点配置区
                        map: 'china', // 表示中国地图
                        roam: true,
                        label: {
                            normal: {
                                show: true, // 是否显示对应地名
                                textStyle: {
                                    color: 'rgba(0,0,0,0.4)'
                                }
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: 'rgba(0, 0, 0, 0.2)'
                            },
                            emphasis: {
                                areaColor: null,
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 20,
                                borderWidth: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    series: [{
                        type: 'scatter',
                        coordinateSystem: 'geo' // 对应上方配置
                    },
                        {
                            name: '启动次数', // 浮动框的标题
                            type: 'map',
                            geoIndex: 0,
                            data: [{
                                name: '广东',
                                value: 1324
                            }] // 这里就是数据，即数组可以单独放在外面也可以直接写
                        }
                    ]
                })
            },
            //搜索回调
            searchItem(val) {
                console.log(val)
            },
            //新增回调
            addNew(val) {
                console.log(val)
            },
            //导入
            leadingItem(val) {
                console.log(val)
            },
            initChart() {
                this.chart = echarts.init(this.$refs.myEchart);
                window.onresize = echarts.init(this.$refs.myEchart).resize;
                // 把配置和数据放这里
                this.chart.setOption({
                    title: {
                        text: 'HEBE节点分布示意图',
                        left: '45%',
                        top: '0px',
                        textStyle: {
                            color: '#fff',
                            opacity: 0.7
                        }
                    },
                    dataRange: {
                        show: false,
                        min: 0,
                        max: 10,
                        text: ['High', 'Low'],
                        realtime: true,
                        calculable: true,
                        color: ['#44a5f6', '#a2d2fb', '#d4eafd']
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                            dataView: {readOnly: false},
                            restore: {},
                            saveAsImage: {}
                        }
                    },
                    geo: {
                        map: 'world',
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        roam: false,
                        silent: true,
                        itemStyle: {
                            normal: {
                                areaColor: '#37376e',
                                borderColor: '#000'
                            },
                            emphasis: {
                                areaColor: '#2a333d'
                            }
                        }
                    },
                    series: [{
                        name: 'Hebe节点分布',
                        type: 'map',
                        mapType: 'world',
                        // zoom: 1.2,
                        mapLocation: {
                            y: 100
                        },
                        data: this.allData,
                        symbolSize: 12,
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            emphasis: {
                                //borderColor: '#fff',
                                borderColor: 'red',
                                borderWidth: 1
                            }
                        }
                    }],
                });
            }
        }


    }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/peer/peersMap.vue